import styled from 'styled-components'

interface ValidateHeightProps {
  fullHeightParent: boolean;
  fullHeight: boolean;
}

const validateFullHeight = (fullHeight: boolean) => fullHeight ? '100vh' : 'calc(100vh - 100px)'

const validateHeight = (props: ValidateHeightProps): string => 
  props.fullHeightParent ? '100%' : validateFullHeight(props.fullHeight);

export const StyledLoadingCircularProgress = styled.div<ValidateHeightProps>`
  height: ${props => validateHeight(props)};
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  bottom: 0;
  left: 0;
  position: fixed;
  z-index: 2000;
  background-color: rgba(255,255,255,0.6);
  flex-direction: column;
`

export const SupportText = styled.p`
  font-size: 16px;
  color: var(--color-contrast-black);
  text-align: center;
  margin-top: 30px;
`
